import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'react-jss';

import useStyles from './useStyles';

const ToastFooter = ({ children, ...rest }) => {
  const theme = useTheme();
  const classes = useStyles({ theme });

  return (
    <div className={classes.wrenchToastFooter} {...rest}>
      {children}
    </div>
  );
};

ToastFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ToastFooter;
